import { TrustpilotWidget } from "shared/TrustpilotWidget";
import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { ProductImages } from "shared/product/ProductSection/ProductImages";
import { HorizontalSeparator } from "ui/HorizontalSeparator";
import { StrapiImage } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

import { AdvantageDetails } from "./AvailableProduct/AdvantageDetails";
import { StickySection } from "./AvailableProduct/StickySection";

export const LegacyProduct = () => {
  const i18n = useI18n();
  const { family, currentVariant } = useProductPageContext();
  const replacement = family?.replacement;

  return (
    <div className="flex flex-col gap-4 items-center py-5 px-8 lg:items-start lg:py-8 lg:w-full">
      {/* Title */}
      <h1 className="mx-auto mt-12 w-max text-2xl text-center lg:mx-0 lg:mt-0 lg:text-left xs:text-3xl">
        {i18n.t(
          "product.legacy.isDone",
          { productName: family.modelName },
          { html: true },
        )}
      </h1>

      {/* Trustpilot */}
      <TrustpilotWidget className="mb-5 lg:-ml-4 lg:w-[420px]" />

      {/* Mobile carousel */}
      <ProductImages className="-mt-5 w-screen min-w-320 lg:hidden" />
      <HorizontalSeparator className="w-screen min-w-320 lg:hidden" />

      {/* Replacement info */}
      <p className="text-2xl text-center bg-yellow lg:text-left">
        {i18n.t(
          "product.legacy.replacementTitle",
          { replacementProductName: replacement?.modelName },
          { html: true },
        )}
      </p>
      <p className="w-full max-w-sm text-center lg:text-left">
        {i18n.t(
          "product.legacy.replacementText",
          { replacementProductName: replacement?.modelName },
          { html: true },
        )}
      </p>

      {/* Product image */}
      <StrapiImage
        size="medium"
        sizes="(max-width: 1024px) 80vw, 33vw"
        image={replacement?.picture ?? undefined}
        className="self-center my-5 w-72 h-72"
      />

      {/* Conditions */}
      <AdvantageDetails
        currentVariant={currentVariant}
        freeChangeAfterMonths={10}
      />

      {/* Sticky section for mobile */}
      <StickySection className="fixed bottom-0 w-screen min-w-320 lg:hidden" />
    </div>
  );
};
